import styled from 'styled-components'

import { media } from '../../../../utils/style-utils'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${media.md`
    gap: 0.25rem;
  `}
`
